import React, { useState } from 'react'

import { Check, MapPin } from 'lucide-react'

import { useFocusReturn } from 'Hooks/useFocusReturn'
import { CustomerAddress } from 'Types'

import { ConfirmAction, DangerButton } from '../../../components/ConfirmAction'

interface AddressCardProps {
  address: CustomerAddress
  deleting: boolean
  onDelete(id: string): void
  onSetPrimary(id: string): void
}

export const AddressCard: React.FC<AddressCardProps> = ({ address, deleting, onDelete, onSetPrimary }) => {
  const [confirming, setConfirming] = useState(false)
  const deleteTriggerRef = useFocusReturn<HTMLButtonElement>(confirming)

  return (
    <article className="user-profile-address-card">
      <div className="user-profile-address-card__body">
        <div className="user-profile-address-card__heading">
          <MapPin aria-hidden size={16} strokeWidth={1.75} />
          <p className="user-profile-address-card__title">
            {address.firstName} {address.lastName}
          </p>
        </div>
        <p className="user-profile-address-card__line">{address.address1}</p>
        <p className="user-profile-address-card__meta">
          {address.city}
          {address.stateIsoCode ? `, ${address.stateIsoCode}` : ''} {address.zipCode}
          {address.countryIsoCode ? ` · ${address.countryIsoCode}` : ''}
        </p>
      </div>
      <div className="user-profile-address-card__footer">
        {confirming ? (
          <ConfirmAction
            confirmLabel="Delete"
            prompt="Delete this address?"
            onCancel={() => setConfirming(false)}
            onConfirm={() => {
              onDelete(address.id)
              setConfirming(false)
            }}
          />
        ) : address.primary ? (
          <span className="user-profile-address-card__default">
            <Check size={16} strokeWidth={1.75} />
            Default
          </span>
        ) : (
          <>
            <button className="user-profile-link-button" type="button" onClick={() => onSetPrimary(address.id)}>
              Set as default
            </button>
            <DangerButton ref={deleteTriggerRef} disabled={deleting} onClick={() => setConfirming(true)}>
              Delete
            </DangerButton>
          </>
        )}
      </div>
    </article>
  )
}
